import { ContainerBloco, ContainerDinamicoEscudeiro, LinhaQuebradaInfo, TituloBloco } from "../../../Common/styles";
import { IProposta } from "../../../../../utility/IProposta";
import { comum } from "../../../../../styles/Themes/light";
import { SpanLucroProfissional, ContainerTooltip, Tooltip } from "./styles";
import { Building2 } from "lucide-react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../../contexts/UserContext";
import { usuarioEhCorrespondente, usuarioEhSolicitante } from "../../../../../helpers/permissoesUsuario";
import MoneyInputEditavel from "../../../../form/MoneyInputEditavel";
import { formatCurrency } from "../../../../../utility/currencyUtils";

interface BlocoValoresProps {
    demanda?: IProposta | null;
    loading?: boolean;
    ehAudiencia?: boolean;
    isEditing?: boolean;
    isDisabled?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
}

export default function BlocoValores({demanda, loading = false, ehAudiencia = false, isEditing = false, isDisabled = false, onChange, onBlur, errors}: BlocoValoresProps) {
    const { user } = useAuth();
    const [corLucro, setCorLucro] = useState<string>('rgb(200, 150, 15)');
    const [corLucroBackground, setCorLucroBackground] = useState<string>('rgba(200, 150, 15, 0.1)');
    const [lucroProfissional, setLucroProfissional] = useState<string>('N/A');
    const [lucroExibido, setLucroExibido] = useState<string>('N/A');
    const [lucroExato, setLucroExato] = useState<string>('');
    const [mostrarTooltip, setMostrarTooltip] = useState(false);

    const handleLucroProfissional = useCallback(() => {
        const valor_lucro = demanda?.lucro_porcentagem;
        const n_a = demanda?.valor_cliente === '0' || demanda?.valor_profissional === '0' 
                    || valor_lucro === undefined || valor_lucro === null || isNaN(Number(valor_lucro));
        if (n_a) {
            setLucroProfissional('N/A');
            setLucroExibido('N/A');
            setLucroExato('');
            setCorLucro('rgb(200, 150, 15)');
            setCorLucroBackground('rgba(200, 150, 15, 0.1)');
        } else {
            const valorString = typeof valor_lucro === 'string' ? valor_lucro.replace(',', '.') : String(valor_lucro);
            const valorNumerico = parseFloat(valorString);
            const valorAbsoluto = Math.abs(valorNumerico);
            const valorFormatado = valorNumerico.toFixed(2).replace('.', ',');
            
            if (valorAbsoluto > 999) {
                setLucroExibido('+999% de lucro');
                setLucroExato(`${valorFormatado}% de lucro`);
            } else {
                setLucroExibido(`${valorFormatado}% de lucro`);
                setLucroExato('');
            }
            
            setLucroProfissional(valorFormatado + `% de lucro`);
            
            if (valorNumerico < 0) {
                setCorLucro('rgb(200, 15, 15)');
                setCorLucroBackground('rgba(200, 15, 15, 0.1)');
            } else {
                setCorLucro('rgb(21, 128, 61)');
                setCorLucroBackground('rgba(21, 128, 61, 0.1)');
            }
        }
    }, [demanda]);

    useEffect(() => {
        handleLucroProfissional();
    }, [handleLucroProfissional]);

    return (
        <ContainerBloco>
            {loading ? (
                <>
                    <Skeleton height={24} width="50%" style={{ marginBottom: '12px' }} />
                    <ContainerDinamicoEscudeiro>
                        <Skeleton height={60} width="100%" style={{ marginBottom: '12px' }} />
                        <Skeleton height={60} width="100%" />
                    </ContainerDinamicoEscudeiro>
                </>
            ) : (
                <>
                <TituloBloco>
                    <Building2 size={16} color={comum.colors.primaryRed400}/>
                    Valores
                </TituloBloco>
                <ContainerDinamicoEscudeiro ehAudiencia={ehAudiencia}>
                    {!usuarioEhCorrespondente(user) && (
                        <LinhaQuebradaInfo> 
                            <span className="label">
                            Valor do Cliente
                        </span>
                        {isEditing ? (
                            <MoneyInputEditavel
                                value={demanda?.valor_cliente}
                                onChange={(value) => onChange && onChange('valor_cliente', value)}
                                onBlur={() => onBlur && onBlur('valor_cliente')}
                                isEditing={isEditing}
                                disabled={isDisabled}
                                error={errors?.valor_cliente}
                            />
                        ) : (
                            <span className="value">
                                {formatCurrency(demanda?.valor_cliente)}
                            </span>
                        )}
                    </LinhaQuebradaInfo>
                    )}
                    {!usuarioEhSolicitante(user) && (
                        <LinhaQuebradaInfo> 
                            <span className="label">
                                Valor do Profissional
                            </span>
                            {isEditing ? (
                                <MoneyInputEditavel
                                    value={demanda?.valor_profissional}
                                    onChange={(value) => onChange && onChange('valor_profissional', value)}
                                    onBlur={() => onBlur && onBlur('valor_profissional')}
                                    isEditing={isEditing}
                                    disabled={isDisabled}
                                    error={errors?.valor_profissional}
                                />
                            ) : (
                                <span className="value">
                                    {formatCurrency(demanda?.valor_profissional)}
                                    {!usuarioEhCorrespondente(user) && (
                                        <ContainerTooltip
                                            onMouseEnter={() => lucroExato && setMostrarTooltip(true)}
                                            onMouseLeave={() => setMostrarTooltip(false)}
                                        >
                                            <SpanLucroProfissional corLucro={corLucro} corLucroBackground={corLucroBackground}>
                                                {lucroExibido}
                                            </SpanLucroProfissional>
                                            {mostrarTooltip && lucroExato && (
                                                <Tooltip>{lucroExato}</Tooltip>
                                            )}
                                        </ContainerTooltip>
                                    )}
                                </span>
                            )}
                        </LinhaQuebradaInfo>
                    )}
                </ContainerDinamicoEscudeiro>
                </>
            )}
        </ContainerBloco>
    )
}

